import { AppDispatch } from 'src/store';
import { createAction } from '@reduxjs/toolkit';

import { fetchMerchantAccountByIdRequest, updateProvidersMerchantRequest } from './requestHandlers';
import { IMerchantAccount } from './types';

export const loadAccountsStart = createAction('accounts_payment/load/start');
export const loadAccountDetailsSuccess = createAction<IMerchantAccount>('accounts_payment/details/load/success');
export const resetAccountDetails = createAction('accounts_payment/details/reset');

export const loadAccountDetailsRequest = (id: string) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    dispatch(loadAccountsStart());

    const data = await fetchMerchantAccountByIdRequest(id);

    if (data) {
      dispatch(loadAccountDetailsSuccess(data));
    }

    return true;
  };
};

export const updateProvidersMerchant = (data: Partial<IMerchantAccount>, merchantType: string) => {
  return async (dispatch: AppDispatch): Promise<IMerchantAccount | null> => {
    const res = await updateProvidersMerchantRequest(data, merchantType);
    if (res) {
      dispatch(loadAccountDetailsSuccess(res));
    }
    return res;
  };
};
